<template>
    <div>
        <div class="calendar_nav">
            <button type="button" :disabled="flag.disableMinusMonth" v-on:click="monthChange(-1)"><i class="fas fa-caret-left"></i></button>
            <p>{{ selectOptions.dates[0].month + ' ' + selectOptions.dates[0].y }}</p>
            <button type="button" :disabled="flag.disablePlusMonth" v-on:click="monthChange(+1)"><i class="fas fa-caret-right"></i></button>
        </div>
        <div class="calendar">
            <div class="calendar_head"> 
                <div v-for="(value) in selectOptions.daysOfWeek" class="calendar_dayname"><span>{{value}}</span></div>
            </div>
            <div v-for="(value) in selectOptions.begBlankDays" class="calendar_day"></div>
            <div v-for="(value) in selectOptions.dates" v-bind:class="['calendar_day', ( (value.full == today) ? 'today' : '') ]">
                <span class="day_number">{{value.d}}</span>
                <a :href="value.auction.full_slug" class="auction" v-if="value.auction">
                    {{ value.auction.title }}
                </a>
            </div>
            <div v-for="(value) in selectOptions.endBlankDays" class="calendar_day"></div>
        </div>
    </div>
</template>
<style>
    .text-danger { font-weight: 700; color:#F00; }
</style>
<script>
    import { mapActions, mapGetters } from "vuex";
    export default {
        props: {
            dates: {
                default: [],
            },
        },
        data() {
            return {
                today: '',
                flag: {
                    watchCurrent:      false,
                    disableMinusMonth: false,
                    disablePlusMonth:  false,
                    disableMinusDay:   false,
                    disablePlusDay:    false,
                    setCalDate:        false,
                },
                current: {
                    month: 0,
                    year: 0,
                },
                selectOptions: {
                    dates : {},
                    daysOfWeek: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    begBlankDays: 0,
                    endBlankDays: 0
                },
            }
        },
        watch: {
            'current.month': function() {
                if( this.current.month == 0 ) {
                    this.current.month = 12;
                    this.current.year = ( parseInt(this.current.year) - 1 );
                }
                if( this.current.month == 13 ) {
                    this.current.month = 1;
                    this.current.year = ( parseInt(this.current.year) + 1 );
                }
                if( this.flag.watchCurrent == true ) {
                    this.getCalendarDates();
                }
                var d = new Date();
                var m = (d.getMonth() + 1);
                var y = d.getFullYear();

                //if( parseInt(this.current.month) == m && parseInt(this.current.year) == y ) {
                //    this.flag.disablePlusMonth = true;
                //}else{
                //    this.flag.disablePlusMonth = false;
                //}

                //if( parseInt(this.current.month) == 1 && parseInt(this.current.year) == 2020 ) {
                //    this.flag.disableMinusMonth = true;
                //}else{
                //    this.flag.disableMinusMonth = false;
                //}
            },
            'current.year': function() {
                if( this.flag.watchCurrent == true ) {
                    this.getCalendarDates();
                }
            },
        },
        created: function() {
            var t = new Date();
            this.today = t.getFullYear() + '-' + leadingZero((t.getMonth() + 1)) + '-' + leadingZero(t.getDate());
            
            this.selectOptions.dates = JSON.parse(this.dates);

	        
            this.setBlankDays();
            
            this.current.month = this.selectOptions.dates[0].m;
            this.current.year  = this.selectOptions.dates[0].y;

            this.$nextTick(function() {
                this.flag.watchCurrent = true;
	        });

        },
        methods: {
            getCalendarDates:function() {
                axios.post('/ajax/calendar-dates', this.current).then(response => {
                    if( !response.data.dates.length == 0 ) {
                        this.selectOptions.dates = response.data.dates;
                        this.setBlankDays();
                    }
                });
            },
            setBlankDays:function() {
                var begDate = new Date(this.selectOptions.dates[0].full);
                var endDate = new Date(this.selectOptions.dates.slice(-1).pop().full);
                var begBlank = 0;
                var endBlank = 0;

                if( begDate.getDay() == 0 ) {
                    begBlank = 6;
                }else if( begDate.getDay() == 1 ) {
                    begBlank = 0;
                }else if( begDate.getDay() == 2 ) {
                    begBlank = 1;
                }else if( begDate.getDay() == 3 ) {
                    begBlank = 2;
                }else if( begDate.getDay() == 4 ) {
                    begBlank = 3;
                }else if( begDate.getDay() == 5 ) {
                    begBlank = 4;
                }else if( begDate.getDay() == 6 ) {
                    begBlank = 5;
                }
                this.selectOptions.begBlankDays = begBlank;

                if( endDate.getDay() == 0 ) {
                    endBlank = 0;
                }else if( endDate.getDay() == 1 ) {
                    endBlank = 6;
                }else if( endDate.getDay() == 2 ) {
                    endBlank = 5;
                }else if( endDate.getDay() == 3 ) {
                    endBlank = 4;
                }else if( endDate.getDay() == 4 ) {
                    endBlank = 3;
                }else if( endDate.getDay() == 5 ) {
                    endBlank = 2;
                }else if( endDate.getDay() == 6 ) {
                    endBlank = 1;
                }
                this.selectOptions.endBlankDays = endBlank;
            },

            monthChange:function(qty) {
                this.current.month = ( parseInt(this.current.month) + parseInt(qty) );
            },
            yearChange:function(qty) {
                this.current.year = ( parseInt(this.current.year) + parseInt(qty) );
            }

        }
    }
    function leadingZero(n) {return n<10 ? '0'+n : n}
</script>